export default __webpack_public_path__ + "static/media/Logo-Oficina.2294cf42.svg";